// extracted by mini-css-extract-plugin
export default {"table":"GraphTable_table__-lEbL"};